import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, Clock, TrendingUp, Network } from 'lucide-react';
import SearchBar from '../components/SearchBar';
import ToolCard from '../components/ToolCard';
import { fetchHomepage } from '../api/client';

const catIcons = ['◆', '▲', '●', '◈', '▾', '✦', '✤', '⬬', '▣', '◇'];

export default function HomePage() {
  const [data, setData] = useState({ categories: [], featured: [], recent: [], popular: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHomepage()
      .then((d) => setData(d))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-inner">
          <h1 className="hero-title">Find the right AI tool for anything.</h1>
          <p className="hero-sub">
            {loading
              ? 'Loading tools...'
              : `${data.categories.reduce((s, c) => s + (c.count || 0), 0).toLocaleString()}+ tools across ${data.categories.length} categories, curated in a tree.`}
          </p>
          <div className="hero-search">
            <SearchBar size="lg" autoFocus />
          </div>
          <div className="hero-cta-row">
            <Link to="/tree" className="pill-btn primary lg">
              <Network size={16} />
              Browse the AI Framework
            </Link>
            <Link to="/category/all" className="pill-btn lg">
              All Tools <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-head">
          <h2>Categories</h2>
          <Link to="/tree" className="section-link">See tree view →</Link>
        </div>
        <div className="category-grid">
          {data.categories.map((c, i) => (
            <Link key={c.slug} to={`/category/${c.slug}`} className="category-card">
              <span className="cat-glyph" aria-hidden>{catIcons[i % catIcons.length]}</span>
              <div className="cat-body">
                <span className="cat-name">{c.name}</span>
                <span className="cat-count">{c.count} tools</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {data.featured?.length > 0 && (
        <section className="section">
          <div className="section-head">
            <h2><Sparkles size={16} className="section-icon" /> Featured tools</h2>
          </div>
          <div className="tool-grid">
            {data.featured.map((t) => (
              <ToolCard key={t.id} tool={t} />
            ))}
          </div>
        </section>
      )}

      <section className="section">
        <div className="section-head">
          <h2><TrendingUp size={16} className="section-icon" /> Popular right now</h2>
          <span className="muted">Based on real click data</span>
        </div>
        {data.popular?.length ? (
          <div className="tool-grid">
            {data.popular.map((t) => (
              <ToolCard key={t.id} tool={t} />
            ))}
          </div>
        ) : (
          <div className="empty-state">
            No click data yet. As users click tools, popular ones will surface here.
          </div>
        )}
      </section>

      <section className="section">
        <div className="section-head">
          <h2><Clock size={16} className="section-icon" /> Recently added</h2>
        </div>
        <div className="tool-grid">
          {data.recent?.map((t) => (
            <ToolCard key={t.id} tool={t} />
          ))}
        </div>
      </section>
    </div>
  );
}
